import { render, staticRenderFns } from "./ArticleCreateUpdate.vue?vue&type=template&id=13d3f53e&scoped=true&"
import script from "./ArticleCreateUpdate.vue?vue&type=script&lang=js&"
export * from "./ArticleCreateUpdate.vue?vue&type=script&lang=js&"
import style0 from "./ArticleCreateUpdate.vue?vue&type=style&index=0&id=13d3f53e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13d3f53e",
  null
  
)

export default component.exports